import { z } from "zod";

/** Valida data YYYY-MM-DD também no CALENDÁRIO (rejeita 2026-02-31), como a API. */
function isValidCalendarDate(value: string): boolean {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return false;
  const date = new Date(Date.UTC(year, month - 1, day));
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
}

/** Validação idêntica à da API: senão o valor viraria default em silêncio. */
export const paramsSchema = z.object({
  REM_DATA_LANCAMENTO: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Informe uma data válida")
    .refine(isValidCalendarDate, "Data inválida no calendário"),
  REM_DIAS_RETROATIVOS_LOTE: z
    .number({ invalid_type_error: "Informe um número" })
    .int("Deve ser inteiro")
    .min(1, "Mínimo 1"),
  REM_EXPURGO_LEDGER_HABILITADO: z.boolean(),
  REM_RETENCAO_LEDGER: z
    .number({ invalid_type_error: "Informe um número" })
    .int("Deve ser inteiro")
    .min(1, "Mínimo 1"),
  REM_RETENCAO_NOTIFICACOES: z
    .number({ invalid_type_error: "Informe um número" })
    .int("Deve ser inteiro")
    .min(1, "Mínimo 1"),
});

export type ParamsFormValues = z.infer<typeof paramsSchema>;

export const createReasonSchema = z.object({
  codigo: z
    .string()
    .regex(/^[A-Z0-9]{2,10}$/, "2–10 caracteres maiúsculos/dígitos, sem espaço"),
  rotulo: z.string().min(1, "Obrigatório").max(60, "Máx. 60 caracteres"),
  ordem: z
    .number({ invalid_type_error: "Informe um número" })
    .int()
    .min(1)
    .max(999),
  ativo: z.boolean(),
});

export type CreateReasonFormValues = z.infer<typeof createReasonSchema>;

export const editReasonSchema = z.object({
  rotulo: z.string().min(1, "Obrigatório").max(60, "Máx. 60 caracteres"),
  ordem: z
    .number({ invalid_type_error: "Informe um número" })
    .int()
    .min(1)
    .max(999),
  ativo: z.boolean(),
});

export type EditReasonFormValues = z.infer<typeof editReasonSchema>;
